const colors = [
  'red', 'orange', 'amber', 'yellow', 'lime', 'green', 'emerald', 
  'teal', 'cyan', 'sky', 'blue', 'indigo', 'violet', 'purple', 
  'fuchsia', 'pink', 'rose'
];

const shades = [300, 400, 500, 600, 700];

const getRandomItem = (array) => {
  return array[Math.floor(Math.random() * array.length)];
};

export const generateRandomGradient = () => {
  const fromColor = getRandomItem(colors);
  let toColor = getRandomItem(colors);
  
  // Ensure we don't get the same color for both ends
  while (toColor === fromColor) {
    toColor = getRandomItem(colors);
  }

  const fromShade = getRandomItem(shades);
  const toShade = getRandomItem(shades);

  return `from-${fromColor}-${fromShade} to-${toColor}-${toShade}`;
};